// PRD §5 — "Default" state: nothing selected in the tree. Right panel shows
// a centered hint instructing the user to pick a node.

import { useTranslation } from 'react-i18next';
import { MousePointerClick } from 'lucide-react';

export function EmptyDetail() {
  const { t } = useTranslation('pro-item-design');
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: 'var(--muted-foreground)',
      }}
    >
      <MousePointerClick size={48} style={{ marginBottom: 16 }} />
      <p style={{ fontSize: 16 }}>{t('detail.empty.title')}</p>
      <p style={{ fontSize: 13, marginTop: 8 }}>{t('detail.empty.hint')}</p>
    </div>
  );
}
